import { Modal } from 'antd';


export const info = (title, content, handleOk) => {
  Modal.info({
    title: title,
    content: (content),
    onOk: handleOk
  });
};

export const successModal = (title, content, handleOk) => {
  Modal.success({
    title: title,
    content: (content),
    onOk: handleOk  });
};

export const errorModal = (title, content, handleOk) => {
  Modal.error({
    title: title,
    content: (content),
    onOk: handleOk
  });
};

export const warning = (title, content, handleOk) => {
  Modal.warning({
    title: title,
    content: (content),
    onOk: handleOk
  });
};
